import {
  GamoraControllerState,
  GamoraControllerStateArgs,
  GamoraControllerStateMap,
} from '@ver.id/libs.internal.gamora';
import { HoruzProtocolChulakMessage } from '../guards/message/index.js';
import { HoruzProtocolChulakMessageModule } from '../modules/message.js';
import { HoruzProtocolChulakStateContext } from './context.js';
import { IHoruz } from '../../../horuz.js';
/**
 * @public
 */
export type HoruzProtocolChulakStateBaseRecvResult =
  | {
      message: HoruzProtocolChulakMessage;
      done: false;
    }
  | {
      done: true;
    };

/**
 * HoruzProtocolChulakState
 *
 * Abstract class that represents the state node
 * @internal
 */
export class HoruzProtocolChulakStateBase<
  TStateMap extends GamoraControllerStateMap,
  TStateContext extends HoruzProtocolChulakStateContext,
  TRoot extends IHoruz,
> extends GamoraControllerState<TStateMap, TStateContext, TRoot> {
  constructor(args: GamoraControllerStateArgs) {
    super(args);
  }

  /**
   * Receive message
   * @param stateContext
   */
  recv(stateContext: TStateContext): HoruzProtocolChulakStateBaseRecvResult {
    const data = this.$root
      .$('queues')
      .$('data')
      .next(stateContext.contextIdentifier);

    if (data.done == false) {
      const message = HoruzProtocolChulakMessageModule.Decode(data.value);

      return {
        done: false,
        message: message,
      };
    }

    return {
      done: true,
    };
  }

  /**
   * Send message
   * @param stateContext
   */
  async send(
    stateContext: TStateContext,
    message: HoruzProtocolChulakMessage,
  ): Promise<void> {
    const data = HoruzProtocolChulakMessageModule.Encode(message);
    return stateContext.ws.send(data);
  }
}
